import type { ButtonSize, ButtonVariant } from '@shared/ui/button';

/** Figma `AlertDialog` 세트(Components, 35:816)의 축 */
export const ALERT_DIALOG_TONES = ['default', 'danger'] as const;
export type AlertDialogTone = (typeof ALERT_DIALOG_TONES)[number];

export const ALERT_DIALOG_STATUSES = ['default', 'loading'] as const;
export type AlertDialogStatus = (typeof ALERT_DIALOG_STATUSES)[number];

/** 판: Dialog(xs) 를 360(`size.dialog.alert`)으로 좁힌 것. 닫기(×) 없음 */
export const ALERT_DIALOG_PANEL_CLASS =
  'relative flex w-(--size-dialog-alert) flex-col overflow-hidden rounded-2xl bg-bg-surface text-fg-default shadow-card';

/** 취소: neutral sm 120 */
export const ALERT_DIALOG_CANCEL_CLASS = 'w-(--size-button-md)';

/**
 * 확인 버튼 — 취소와 같은 sm 120(높이 32). tone 은 색만 바꾼다: default = primary, danger = danger("삭제").
 * (예전 Figma 는 danger 만 md · 글자 너비라 취소와 크기가 달랐다 — 2026-10-07 사용자 요청으로 통일, Figma 도 고침)
 */
export const ALERT_DIALOG_CONFIRM: Record<
  AlertDialogTone,
  { variant: ButtonVariant; size: ButtonSize; className: string }
> = {
  default: { variant: 'primary', size: 'sm', className: 'w-(--size-button-md)' },
  danger: { variant: 'danger', size: 'sm', className: 'w-(--size-button-md)' },
};
